import React from "react";
import logoNavarra from "../../assets/img/logo-gobierno-navarra.png";
import logoInm from "../../assets/img/logo-memoria.png";

const Footer = () => {
  return (
    <footer className="mt-auto">

      <div className="px-6 is-flex is-flex-wrap-wrap is-justify-content-flex-end is-align-items-flex-end gap-7">
        <a href="https://www.navarra.es/">
          <img loading="lazy" src={logoNavarra} alt="Gobierno de Navarra" width="255" height="54" />

        </a>
        <a href="https://pazyconvivencia.navarra.es/es/inm">
          <img loading="lazy" src={logoInm} alt="Instituto Navarro de la Memoria" width="133" height="30" />
        </a>
      </div>
    </footer>


  );
};

export default Footer;
